import { useEffect, useState } from 'react';
import getPriceByPlan from '../utils/getPriceByPlan';

type UseGetUnitsPriceProps = {
  beneficiaryAllPlans: any[];
  unitsPrice: number;
  simulatedRetentionPercent: number;
  includeBeneficiaryNotVestedUnits: boolean;
};

export const useGetTotals = ({
  beneficiaryAllPlans,
  unitsPrice,
  simulatedRetentionPercent,
  includeBeneficiaryNotVestedUnits,
}: UseGetUnitsPriceProps) => {
  const [simulatedTotal, setSimulatedTotal] = useState<number>(0);
  const [retentionTotal, setRetentionTotal] = useState<number>(0);

  useEffect(() => {
    const simulatedTotal = beneficiaryAllPlans.reduce(
      (acc, beneficiaryData) => {
        const resultPrice = getPriceByPlan(
          beneficiaryData,
          unitsPrice,
          includeBeneficiaryNotVestedUnits
        );

        return acc + resultPrice;
      },
      0
    );

    setSimulatedTotal(simulatedTotal);

    const retentionTotal = simulatedTotal * (simulatedRetentionPercent / 100);
    setRetentionTotal(retentionTotal);
  }, [
    beneficiaryAllPlans,
    unitsPrice,
    simulatedRetentionPercent,
    includeBeneficiaryNotVestedUnits,
  ]);

  return {
    data: { simulatedTotal, retentionTotal },
    isLoading: false,
    isError: false,
    actions: {},
  };
};
